import { useCallback, useState } from 'react';

import { BridgeEventMethod, FullMessage } from '@scaleaq/sitecontrol-lib';
import { v4 as uuidv4 } from 'uuid';

import { useBridgeRegistration } from '../registerAndSubscribe';
import { useEventSubscription } from './useEventSubscription.ts';

type useGetAllLastMessages_IIProps = {
  enable: boolean;
  listenerId?: string;
  maxMessages?: number;
};

export const useGetAllLastMessages = ({
  enable,
  listenerId = uuidv4(),
  maxMessages = 20,
}: useGetAllLastMessages_IIProps) => {
  const [messages, setMessages] = useState<FullMessage[]>([]);
  const [isEnabled, setIsEnabled] = useState<boolean>(enable);

  const calBack = useCallback(
    (message: FullMessage) => {
      if (!isEnabled || !message.listenerIds.includes(listenerId)) return;
      setMessages(messageList => {
        if (messageList.length > maxMessages - 1) {
          //sort old by context.timestamp
          const sorted = messageList.sort((a, b) => {
            return (
              new Date(a.context.timestamp).getTime() - new Date(b.context.timestamp).getTime()
            );
          });
          return [...sorted.slice(1), message];
        }
        return [...messageList, message];
      });
    },
    [isEnabled, listenerId, maxMessages]
  );
  // Always, first register the event handler
  useBridgeRegistration({
    bridgeEventMethod: BridgeEventMethod.FullMessage,
    eventCallback: calBack,
  });

  const { isLoading, isError } = useEventSubscription({
    eventNames: ['ISiteControlEvent'],
    listenerId,
    includeEphemeral: false,
  });

  return { isLoading, messages, isEnabled, setIsEnabled, isError };
};
